export const SUPPLIER_PRODUCT_CREATE_REQUEST = 'SUPPLIER_PRODUCT_CREATE_REQUEST'
export const SUPPLIER_PRODUCT_CREATE_SUCCESS = 'SUPPLIER_PRODUCT_CREATE_SUCCESS'
export const SUPPLIER_PRODUCT_CREATE_FAIL = 'SUPPLIER_PRODUCT_CREATE_FAIL'

export const SUPPLIER_PRODUCT_LIST_REQUEST = 'SUPPLIER_PRODUCT_LIST_REQUEST'
export const SUPPLIER_PRODUCT_LIST_SUCCESS = 'SUPPLIER_PRODUCT_LIST_SUCCESS'
export const SUPPLIER_PRODUCT_LIST_FAIL = 'SUPPLIER_PRODUCT_LIST_FAIL'

export const SUPPLIER_PRODUCT_LIST_MY_REQUEST = 'SUPPLIER_PRODUCT_LIST_MY_REQUEST'
export const SUPPLIER_PRODUCT_LIST_MY_SUCCESS = 'SUPPLIER_PRODUCT_LIST_MY_SUCCESS'
export const SUPPLIER_PRODUCT_LIST_MY_FAIL = 'SUPPLIER_PRODUCT_LIST_MY_FAIL'

export const SUPPLIER_PRODUCT_REQUEST = 'SUPPLIER_PRODUCT_REQUEST'
export const SUPPLIER_PRODUCT_SUCCESS = 'SUPPLIER_PRODUCT_SUCCESS'
export const SUPPLIER_PRODUCT_FAIL = 'SUPPLIER_PRODUCT_FAIL'

// Reviews
export const FARMER_PRODUCT_CREATE_REVIEW_REQUEST = 'FARMER_PRODUCT_CREATE_REVIEW_REQUEST'
export const FARMER_PRODUCT_CREATE_REVIEW_SUCCESS = 'FARMER_PRODUCT_CREATE_REVIEW_SUCCESS'
export const FARMER_PRODUCT_CREATE_REVIEW_FAIL = 'FARMER_PRODUCT_CREATE_REVIEW_FAIL'
export const FARMER_PRODUCT_CREATE_REVIEW_RESET = 'FARMER_PRODUCT_CREATE_REVIEW_RESET'

export const SUPPLIER_PRODUCT_UPDATE_REQUEST = 'SUPPLIER_PRODUCT_UPDATE_REQUEST'
export const SUPPLIER_PRODUCT_UPDATE_SUCCESS = 'SUPPLIER_PRODUCT_UPDATE_SUCCESS'
export const SUPPLIER_PRODUCT_UPDATE_FAIL = 'SUPPLIER_PRODUCT_UPDATE_FAIL'
export const SUPPLIER_PRODUCT_UPDATE_RESET = 'SUPPLIER_PRODUCT_UPDATE_RESET'

// For all

export const SUPPLIER_PRODUCT_FOR_ALL_REQUEST = 'SUPPLIER_PRODUCT_FOR_ALL_REQUEST'
export const SUPPLIER_PRODUCT_FOR_ALL_SUCCESS = 'SUPPLIER_PRODUCT_FOR_ALL_SUCCESS'
export const SUPPLIER_PRODUCT_FOR_ALL_FAIL = 'SUPPLIER_PRODUCT_FOR_ALL_FAIL'